module.exports = __webpack_public_path__ + "img/product_header_2023.ae755396.png";